package horcrux.frontend.common.views.documents

import horcrux.common.api.dtos.types.DocumentMetadata
import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.State
import react.FC
import react.Props

external interface DocumentNavigatorProps : Props {
    var documentMetadataListState: State<List<DocumentMetadata>>
    var documentMetadataFilter: (DocumentMetadata) -> Boolean
    var globalAppState: GlobalAppState

}

val DocumentNavigator: FC<DocumentNavigatorProps> = FC { props ->
    props.documentMetadataListState.get().filter(props.documentMetadataFilter).sortedBy { it.createdAt }
        .forEach { documentMetadata: DocumentMetadata ->
            DocumentExplorerDialog {
                this.documentMetadata = documentMetadata
                this.documentMetadataListState = props.documentMetadataListState
                this.globalAppState = props.globalAppState
            }
        }
}
